var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.5833C6.25 12.5959 5.42919 13.4167 4.41667 13.4167C3.40414 13.4167 2.58333 12.5959 2.58333 11.5833M6.25 11.5833C6.25 10.5708 5.42919 9.75 4.41667 9.75C3.40414 9.75 2.58333 10.5708 2.58333 11.5833M6.25 11.5833H11.75M2.58333 11.5833H0.75V6.08333M15.4167 11.5833C15.4167 12.5959 14.5959 13.4167 13.5833 13.4167C12.5708 13.4167 11.75 12.5959 11.75 11.5833M15.4167 11.5833C15.4167 10.5708 14.5959 9.75 13.5833 9.75C12.5708 9.75 11.75 10.5708 11.75 11.5833M15.4167 11.5833H17.25V7.91667C17.25 7.43044 17.0568 6.96412 16.713 6.6203C16.3692 6.27649 15.9029 6.08333 15.4167 6.08333H14.5M0.75 6.08333L2.58333 1.5H10.8333L14.5 6.08333M0.75 6.08333H14.5M9 6.08333V1.5",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.8f9ea06b16208c362a38a47078ce5ef5.svg";
export { ForwardRef as ReactComponent };